import { radianToDegree } from "common/utils/math";

export function textRightSideUp(rawAngleCW: number, planRotationRads: number = 0): number {
  const angleCW = (rawAngleCW + radianToDegree(planRotationRads)) % 360;

  //flips the slope text to so that words remain right-side-up
  if (angleCW >= 0 && angleCW < 180) {
    return 270;
  } else {
    return 90;
  }
}

export function textRightSideUpRads(rawAngleRadsCW: number, planRotationRads: number = 0): number {
  const angleCW = (rawAngleRadsCW + planRotationRads) % (2 * Math.PI);

  //flips the slope text to so that words remain right-side-up
  if (angleCW >= 0 && angleCW < Math.PI) {
    return 1.5 * Math.PI;
  } else {
    return 0.5 * Math.PI;
  }
}
